module.exports = __webpack_public_path__ + "bm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bm.svg
// module id = 456
// module chunks = 0